import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Prose, TextAlpha } from '@yonderland/andes-react';
import { axiosClient } from '@as-react/common-utils';
import { useQuery } from '@tanstack/react-query';
import { useBasketOverviewConfig } from '../../../../context/ComponentConfigContext';
export const TermsAndConditions = () => {
    const { totalMiniBlock } = useBasketOverviewConfig();
    const { data: terms } = useQuery({
        queryKey: ['termsAndConditions'],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: totalMiniBlock === null || totalMiniBlock === void 0 ? void 0 : totalMiniBlock.termsUrl,
                withCredentials: true,
            };
            const response = yield axiosClient.request(axiosConfig);
            return response.data;
        }),
        enabled: Boolean(totalMiniBlock === null || totalMiniBlock === void 0 ? void 0 : totalMiniBlock.termsUrl),
    });
    if (!terms)
        return null;
    return (_jsx(Box, { backgroundColor: "quiet-3", padding: "4", children: _jsx(TextAlpha, { variant: "bodyS", testId: "terms_and_conditions", alignment: "center", children: _jsx(Prose, { html: terms }) }) }));
};
